import { ExperiencePayload } from '~/components/Experiences/hooks';

import { ExperienceOffer, ExperienceOfferImage } from '~/services/ExperiencesService';

export const handleImagesPayload = async (payload: ExperiencePayload, experience: ExperienceOffer) => {
  let images: Array<ExperienceOfferImage> = payload?.images ?? experience.images;

  if (!payload?.imagesToRemove && !payload?.images) {
    return;
  }

  if (payload?.imagesToRemove) {
    images = images.filter((image) => !payload.imagesToRemove.includes(image.id));
  }

  // these keys are front-end only
  // we don't need to send to the backend
  // because the backend will not use it.
  delete payload.imagesToRemove;

  return images;
};
